module.exports = __webpack_public_path__ + "static/btn04-2385c4bdb82a67594dc3844ba3bc9755.png";